<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="row">
            <div class="col-md-8">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">{{ isEditMode ? 'Edição de ' : 'Cadastro de '}}Contas a Pagar</h1>
                        <p class="welcome-message">
                            <button mat-icon-button [routerLink]="rotaVoltar">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            Preencha os dados da conta a pagar
                        </p>
                        @if (idNFeEntradaOrigem) {
                        <p class="welcome-message mb-0">
                            Documento de origem:
                            <a [routerLink]="['/suprimentos/nota-fiscal-entrada/documento', idNFeEntradaOrigem]" [queryParams]="{ modo: 'visualizar' }">NF-e de entrada</a>
                        </p>
                        }
                        @if (idNFSeEntradaOrigem) {
                        <p class="welcome-message mb-0">
                            Documento de origem:
                            <a [routerLink]="['/suprimentos/servicos-tomados/editar', idNFSeEntradaOrigem]">NFS-e de entrada</a>
                        </p>
                        }
                    </div>
                </div>
            </div>

            @if (isEditMode && isAgrupado) {
            <div class="col-md-4 d-flex justify-content-end align-items-start">
                <button mat-button type="button" (click)="desagrupar()" [disabled]="desagrupando"
                    matTooltip="Desfaz o agrupamento: reabre as parcelas originais (em aberto) e exclui este lançamento consolidado."
                    matTooltipPosition="below">
                    @if (desagrupando) {
                    <mat-spinner diameter="16"></mat-spinner>
                    } @else {
                    <mat-icon class="material-symbols-outlined">call_split</mat-icon>
                    Desagrupar lançamento
                    }
                </button>
            </div>
            }
        </div>

        @if (isLoading || isLoadingLookups) {
        <div class="row">
            <div class="col-12 mb-4">
                <app-loading-box [height]="'30'" [width]="'250'" [margin]="'0 0 20px 0'"></app-loading-box>

                <div class="row">
                    <div class="col-12 mb-3">
                        <app-loading-box [height]="'150'"></app-loading-box>
                    </div>
                    <div class="col-6 mb-3">
                        <app-loading-box [height]="'100'"></app-loading-box>
                    </div>
                    <div class="col-6 mb-3">
                        <app-loading-box [height]="'100'"></app-loading-box>
                    </div>
                </div>
            </div>
        </div>
        } @else {

        <form [formGroup]="form" (ngSubmit)="salvar()">

            <app-page-scroll-spy [sections]="sections"></app-page-scroll-spy>

            <div class="section-container" id="dados-gerais">
                <div class="section-title">
                    <mat-icon>assignment</mat-icon>
                    <span>Dados Gerais</span>
                </div>
                <app-contas-pagar-dados-gerais [parentForm]="form"
                    [listaCategoriasFinanceiras]="lookups?.categoriasFinanceiras ?? []" [currencyMask]="currencyMask">
                </app-contas-pagar-dados-gerais>
            </div>

            <div class="section-container" id="rateio">
                <div class="section-title">
                    <mat-icon>pie_chart</mat-icon>
                    <span>Centro de Custo</span>
                </div>
                <app-contas-pagar-centro-custo [parentForm]="form" [valorTotalDoc]="valorTotalDocumento"
                    [listaCentrosCusto]="lookups?.centrosCusto ?? []"
                    [listaGridConfiguracoes]="lookups?.rateiosCentroCusto ?? []" [currencyMask]="currencyMask"
                    [percentageMask]="percentageMask" [isCentroCustoObrigatorio]="isObrigatorio('id_centro_custo')">
                </app-contas-pagar-centro-custo>
            </div>

            <div class="section-container" id="parcelamento">
                <div class="section-title">
                    <mat-icon>calendar_today</mat-icon>
                    <span>Parcelamento / Repetição</span>
                </div>
                <app-contas-pagar-parcelamento [parentForm]="form" [isEditMode]="isEditMode" [qtdParcelas]="qtdParcelas"
                    [idContasPagar]="idContasPagar" [hasParcelasEmAberto]="hasParcelasEmAberto"
                    [listaTiposParcelamento]="lookups?.tiposParcelamento ?? []"
                    [listaFrequencia]="lookups?.frequenciasRecorrencia ?? []"
                    [listaContaFinanceira]="lookups?.contasFinanceiras ?? []"
                    [listaFormaPagamento]="lookups?.formasPagamento ?? []" [currencyMask]="currencyMask"
                    [integerMask]="integerMask"
                    [camposObrigatorios]="camposObrigatorios" (renegociarClick)="abrirRenegociacao()">
                </app-contas-pagar-parcelamento>
            </div>

            @if (isEditMode && qtdParcelas === 1) {
            <div class="section-container" id="previsao">
                <div class="section-title">
                    <mat-icon>monetization_on</mat-icon>
                    <span>Previsão de Pagamento</span>
                </div>
                <app-contas-pagar-previsao [parentForm]="form"
                    [currencyMask]="currencyMask"></app-contas-pagar-previsao>
            </div>
            }

            <div class="section-container" id="complementos">
                <div class="section-title">
                    <mat-icon>description</mat-icon>
                    <span>Arquivos e Complementos</span>
                </div>
                <app-contas-pagar-complementares [parentForm]="form" [camposObrigatorios]="camposObrigatorios"
                    [tagsControl]="tagsControl" [listaTag]="lookups?.tags ?? []"
                    [listaFormaPagamento]="lookups?.formasPagamento ?? []"
                    [mostrarTags]="mostrarTags"></app-contas-pagar-complementares>
            </div>

        </form>
        }
    </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="desagrupando" (cancelar)="cancelar()" (salvar)="salvar()"></app-footer-action>
